// Copyright (c) 2017 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import criteria from './criteria';
import gridApi from './grid-api';
import isPrintClaimDisabled from './is-print-claim-disabled';
import report from './report';
import reportIsScrollable from './report-is-scrollable';
import selectedDealers from './dealer-selection';
import selectedStatuses from './status-selection';
import showNoResultsFound from '../../shared/reducers/show-no-results-found';
import showSelectAll from './show-select-all';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    criteria,
    gridApi,
    isPrintClaimDisabled,
    report,
    reportIsScrollable,
    selectedDealers,
    selectedStatuses,
    showNoResultsFound,
    showSelectAll
});



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/reducers/index.js